import { createContext, useContext, useEffect, useState } from "react";
import { t } from "@/data/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    const saved = window.localStorage.getItem("manoly-lang");
    if (saved && t[saved]) return saved;
    return "es";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("manoly-lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = { lang, setLang, tr: t[lang] };
  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
